import keyMirror from "keymirror";


const TrainingConstants = {
	ActionTypes: keyMirror({
		// hiring management
		CHANGEHIRINGMANAGEMENT: null,
		SELECTHIRINGMANAGEMENT: null,

		// interview management
		CHANGEINTERVIEWMANAGEMENT: null,
		SELECTINTERVIEWMANAGEMENT: null,

		// notification template
		CHANGENOTIFICATIONTEMPLATE: null,
		SELECTNOTIFICATIONTEMPLATE: null,
		UPDATENOTIFICATIONTEMPLATE: null,

		// recruitment requirement
		CHANGERECUITMENTREQUIREMENT: null,
		SELECTRECUITMENTREQUIREMENT: null,
		UPDATERECUITMENTREQUIREMENT: null,

		// recruitment setting
		CHANGERECRUITMENTSETTING: null,
		SELECTRECRUITMENTSETTING: null,
		UPDATERECRUITMENTSETTING: null,

		// recruistment statistics
		CHANGERECRUITMENTSTATISTICS: null,
		SELECTRECRUITMENTSTATISTICS: null,

		// resume library
		CHANGERESUMELIBRARY: null,
		SELECTRESUMELIBRARY: null,
		UPDATERESUMELIBRARY: null,
	})
}


export default TrainingConstants;


// WEBPACK FOOTER //
// ./src/constants/recruitment-constants.js